import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const GROWTH_REPORT_ROUTE = {
  name: 'growthreport/:activityId',
  route(classId: string, activityId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'growthreport', activityId];
  }
};